module.exports = __webpack_public_path__ + "fonts/Gilroy-LightItalic.a0904c2a.ttf";